import React from 'react';

import { Control } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { LbInput, LbSelect, LbDatePicker } from '@infoods/lifebase-ui';

import { ComboBox } from '../../../../../shared/components/form-components';
import {
  CheckboxCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';
import { statusOptions } from './GeneralFilters.settings';
import { CustomerCommunicationFilterFormValues } from '../../../../interfaces/CustomerCommunicationFilters';
import { customerCommunicationStore } from '../../../../stores/customerCommunicationStore';
import { useGroupList } from '../../../../../customer-group';
import { CustomFiltersSelector } from '../../../../../shared/features/custom-filter';

type GeneralFiltersProps = {
  control: Control<CustomerCommunicationFilterFormValues>;
  onReset: () => void;
};

const GeneralFilters = observer(({ control, onReset }: GeneralFiltersProps) => {
  const { groupListOptionWithAll } = useGroupList();
  const { isShowCoachColumn, isShowLocationColumn, selectMethod } =
    customerCommunicationStore;
  const { getMasterCheckboxProps } = selectMethod;

  const inputGeneralProps = {
    control,
    variant: 'outlined',
    size: 'small',
  } as const;

  return (
    <GridTableRow variant="filter" component="form">
      <CheckboxCell showCheckbox {...getMasterCheckboxProps()}>
        <LbInput
          {...inputGeneralProps}
          name="generalFilter.fullName"
          placeholder="Name"
          dataTestId="name-input"
        />
      </CheckboxCell>
      <GridTableRow variant="unstyled">
        {isShowLocationColumn && (
          <LbInput
            {...inputGeneralProps}
            name="generalFilter.entityName"
            placeholder="Location"
            dataTestId="location-input"
          />
        )}
        <ComboBox
          {...inputGeneralProps}
          name="generalFilter.customerGroupId"
          options={groupListOptionWithAll}
          defaultValue=""
          dataTestId="group-input"
        />
        {isShowCoachColumn && (
          <LbInput
            {...inputGeneralProps}
            name="generalFilter.coachName"
            placeholder="Name"
            dataTestId="coach-input"
          />
        )}
        <LbDatePicker {...inputGeneralProps} name="generalFilter.startDate" />
        <LbSelect
          {...inputGeneralProps}
          name="generalFilter.status"
          options={statusOptions}
          displayEmpty
          dataTestId="status-input"
        />
        <CustomFiltersSelector {...inputGeneralProps} name="customFilterId" />
      </GridTableRow>
      <Button variant="outlined" size="small" type="reset" fullWidth onClick={onReset}>
        Clear All
      </Button>
    </GridTableRow>
  );
});

export { GeneralFilters };
